/**
 * QA Console — service facade
 *
 * component ทุกตัวเรียกผ่านไฟล์นี้ไฟล์เดียว ไม่ import จากไฟล์ service ตรง ๆ
 * (กฎเหล็กข้อ 1 ของ docs/qa-console/QA-Console-Frontend-Plan.md)
 *
 * Q10 — **ไม่มีโหมดอีกต่อไป** · ชั้นข้อมูลจำลองและชั้นผสมถูกลบทั้งชั้น พร้อมสวิตช์ env
 *    ที่เคยเลือกระหว่างสองอัน · ไฟล์นี้จึงเหลือหน้าที่เดียว: รวม `qaConsoleApi.js`
 *    (เคส · คะแนน · สถิติ · ค่าตั้ง) เข้ากับ `qaRecommendApi.js` (คำตอบที่แนะนำ)
 *    ให้เป็นชื่อชุดเดียวที่หน้าจอเรียก
 *
 * ⚠️ ผลที่ตามมาซึ่งต้องรู้: ฐานที่ยังไม่มีเคสจะเห็น **สถานะว่าง** ไม่ใช่ข้อมูลตัวอย่าง
 *    การสาธิตต่อจากนี้ต้อง seed ข้อมูลจริงในฐานทดสอบ · เจตนาคือแบบนั้น — ตัวเลข
 *    ที่แต่งขึ้นแต่หน้าตาเหมือนของจริงคือสิ่งที่ทำให้คนตัดสินใจผิดโดยไม่มีใครจับได้
 *
 * ⚠️ ค่าตั้งทุกแท็บลง `cc.QaSettings` จริงเสมอ (rubric / policy / evaluator / pipeline /
 *    masking / NBA / prechat routing / feedback reasons / sentiment) — เคยมีเส้นทาง
 *    ที่บันทึกลง localStorage แล้วขึ้นว่า "บันทึกแล้ว" ทั้งที่ worker ไม่เคยเห็นค่านั้น
 *    ซึ่งผิดแบบเงียบที่สุด เพราะคะแนนยังออกทุกวันด้วยเกณฑ์เก่า · เส้นทางนั้นหายไปแล้ว
 *
 * แผนงาน: docs/qa-console/QA-Console-Backend-Plan.md
 */

import * as realApi from './qaConsoleApi';
import * as recommendApi from './qaRecommendApi';

export default {
  ...realApi,

  // QA Recommend — คนละไฟล์เพราะเป็นคนละฟีเจอร์ (คำตอบที่แนะนำระหว่างสนทนา ไม่ใช่ QA)
  // แต่ต้องอยู่บน facade เดียวกันตามกฎเหล็กข้อ 1 · เลือกเฉพาะตัวที่หน้าจอเรียก
  // ไม่ spread ทั้งโมดูล เพื่อไม่ให้ helper ภายในของมันหลุดออกมาเป็นสัญญาสาธารณะ
  getRecommendSetting: recommendApi.getRecommendSetting,
  getRecommendModels: recommendApi.getRecommendModels,
  saveRecommendSetting: recommendApi.saveRecommendSetting,
  getCaseRecommend: recommendApi.getCaseRecommend,
  setSuggestionUsed: recommendApi.setSuggestionUsed,
  getRecommendQueue: recommendApi.getRecommendQueue,
  endRecommendConversation: recommendApi.endRecommendConversation,
};

/**
 * QA Recommend — named export ชุดเดิม
 *
 * ⚠️ ห้ามลบ · component หลายตัว (QaRecommendSettings · QACaseDetail) import แบบ named
 *    จากไฟล์นี้อยู่ · ยังนับว่าเคารพกฎเหล็กข้อ 1 เพราะยังผ่าน facade ตัวเดียวกัน
 */
export {
  getRecommendSetting,
  getRecommendModels,
  saveRecommendSetting,
  getCaseRecommend,
  setSuggestionUsed,
  getRecommendQueue,
  endRecommendConversation,
} from './qaRecommendApi';
